import { generateContext } from '@/context/utils';
import reducer from '@/context/search/reducer';
import initialState from '@/context/search/state';
import actions from '@/context/search/actions';

const { SearchProvider, useSearchContext } = generateContext(
  'SearchProvider',
  'useSearchContext',
  initialState,
  reducer,
  actions,
);

export { SearchProvider, useSearchContext };
